import { ChartAreasplineVariantIcon } from './ChartAreasplineVariantIcon';

/**
 * author: Michael Richins
 * id C55BFF6F-469B-4D28-835B-537BED8DE99D
 * name chart-areaspline-variant
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-areaspline-variant.svg
 * tags
 * - Math 
 */
export const ReportAreasplineVariantIcon = ChartAreasplineVariantIcon;
export default ReportAreasplineVariantIcon